<template>
    <div>

        <form @submit.prevent="onHandleStore" data-vv-scope="sites">
            <b-row>

                <b-col md="12">
                    <b-form-group>
                        <label>Nombre</label>
                        <b-form-input v-model="site.name" placeholder="Ingrese el nombre de la locación" name="name"
                            data-vv-as=" " v-validate="'required'"></b-form-input>
                        <div class="text-danger span-error small" v-text="errors.first('sites.name')" />
                    </b-form-group>
                </b-col>
                <b-col md="12">
                    <b-form-group>
                        <label class="w-100">Descripción</label>
                        <b-form-input v-model="site.description" placeholder="Ingrese la descripción de la locación"
                            name="description" data-vv-as=" " v-validate="''"></b-form-input>
                        <div class="text-danger span-error small" v-text="errors.first('sites.description')" />
                    </b-form-group>
                </b-col>

            </b-row>
        </form>

        <div class="d-flex justify-content-end align-items-center mt-4">
            <b-button v-if="modal" type="reset" @click="onClose"> <i class="fa fa-reply mr-1"></i>Cancelar</b-button>
            <b-button class="ml-2" type="submit" variant="primary" @click="onHandleSave"><i
                    class="fa fa-save mr-1"></i>Guardar</b-button>
        </div>
    </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex';
export default {
    name: 'SitesForm',
    props: {
        modal: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        ...mapState('sites', [
            'site',
        ]),
    },
    methods: {
        ...mapMutations('sites', [
            'setSiteDefault',
        ]),

        ...mapActions('sites', [
            'storeSite',
            'listSites',
            'updateSite',
        ]),

        onClose() {
            this.setSiteDefault();
            if (this.modal) {
                this.$bvModal.hide('modal-sites');
            }
        },

        async onHandleSave() {
            const result = await this.$validator.validateAll('sites');
            if (result) {
                const action = this.site.id ? this.updateSite : this.storeSite;
                const res = await action({ site: this.site, company_id: this.$route.params.id });
                if (res) {
                    await this.getAndClose();
                }
            }
        },

        async getAndClose() {
            this.onClose();
            await this.listSites({ company_id: this.$route.params.id });
        },
    }
}

</script>
